<!--
  ~ Copyright (c) 2023 Irian Software Development SRL. All Rights Reserved.
  ~ This software is the proprietary information of Irian Software Development SRL.
  ~ Use is subject to license and non-disclosure terms
  -->

<form [formGroup]="form">

  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.name' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <bs-autocomplete
        (queryChange)="filterPerson($event, 'name')"
        (selected)="onAutoCompleteSelect($event)"
        *ngIf="new"
        [readonly]="found"
        [items]="people"
        [delay]="500"
        [maxlength]="100"
        class="full-width"
        [displayWith]="getPersonDisplayLabel"
        data-testid="name-autocomplete"
        [compareWith]="comparePersonByName"
        formControlName="name">
        <ng-template bsItem let-value>
          <span>Name: {{value.name}} Cnp: {{value.cnp}} </span>
        </ng-template>
      </bs-autocomplete>
      <input *ngIf="!new" formControlName="name" maxlength="100" pInputText class="full-width"  type="text"  data-testid="name-input"/>
    </div>

  </div>


  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.cnp' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <bs-autocomplete
        (queryChange)="filterPerson($event, 'cnp')"
        (selected)="onAutoCompleteSelect($event)"
        *ngIf="new"
        [readonly]="found"
        [items]="people"
        [delay]="500"
        [maxlength]="100"
        formControlName="cnp"
        class="full-width"
        data-testid="cnp-autocomplete"
        [displayWith]="getPersonDisplayLabel"
        [compareWith]="comparePersonByName">
        <ng-template bsItem let-value>
          <span>Name: {{value.name}} Cnp: {{value.cnp}} </span>
        </ng-template>
      </bs-autocomplete>


      <input *ngIf="!new" formControlName="cnp" maxlength="100" pInputText type="text"   class="full-width" data-testid="cnp-input" />
    </div>
  </div>


  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.idSeries' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <input [readonly]="found" formControlName="idSeries" maxlength="2" pInputText
             type="text" class="full-width" data-testid="id-series-input" />
    </div>
  </div>


  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.idNumber' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <bs-autocomplete
        (queryChange)="filterPerson($event, 'idNumber')"
        (selected)="onAutoCompleteSelect($event)"
        *ngIf="new"
        [readonly]="found"
        [items]="people"
        [delay]="500"
        [maxlength]="6"
        class="full-width"
        [displayWith]="getPersonDisplayLabel"
        [compareWith]="comparePersonByName"
        data-testid="id-number-autocomplete"
        formControlName="idNumber">
        <ng-template bsItem let-value>
          <span>Name: {{value.name}} Cnp: {{value.cnp}} </span>
        </ng-template>
      </bs-autocomplete>
      <input *ngIf="!new" formControlName="idNumber" maxlength="100" pInputText type="text" class="full-width"  data-testid="id-number-input" />
    </div>
  </div>


  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.address' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <input formControlName="address" maxlength="100" pInputText type="text" class="full-width" data-testid="address-input" />
    </div>
  </div>


  <div class="row">
    <div class="col-2 col-lg-1 p">
      <label>{{'pwl.county' | translate}}</label>
    </div>
    <div class="col-4 col-lg-3 p">
      <input formControlName="county" maxlength="20" pInputText type="text" class="full-width" data-testid="county-input" />
    </div>
  </div>
</form>
<p-messages [(value)]="msgs"></p-messages>
